import { registerQueryCallback } from './queryCallbackRegistry'

import { isRetiredLegacySettingsTab, legacySettingsTabRouteName } from '@/features/workspace-settings'

/**
 * App-side composition for v3's `?selected_tab` settings deep link (ORP-19899, precondition 3 of
 * the ORP-18893 cutover): module 22 owns the legacy tab vocabulary, the shell owns registration and
 * the redirect — the same split `registerReportQueryCallbacks` uses for `?report_id`.
 *
 * A tab that cannot name a pane still resolves — to the user's first visible one, the same landing
 * `/settings` would have chosen. Nothing comes back only when the registry holds no visible pane at
 * all, and then there is nowhere to send anyone. See `legacySettingsTab.ts` for which tabs fall
 * back and why the fallback is an explicit destination rather than a no-op.
 *
 * Registration must run AFTER `installWorkspaceSettingsPanes()` — the resolver reads the live nav
 * registry, so a handler registered before it is populated would resolve nothing. `bootstrap.ts`
 * orders it that way; the seam itself only fires on navigation, long after both.
 */
export function registerSettingsQueryCallbacks(): void {
  registerQueryCallback('selected_tab', ({ value }) => {
    // A pane that left the app (ORP-27468's AI assistants tab) lands on home, as in v3.
    if (isRetiredLegacySettingsTab(value)) return { redirect: { path: '/' } }
    const routeName = legacySettingsTabRouteName(value)
    return routeName ? { redirect: { name: routeName } } : undefined
  })
}
